module.exports = __webpack_public_path__ + "img/weather-app.3acbe920.png";